import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';

import { IFilterNumber } from '@shared/models/graphql';

import { Store } from '@ngrx/store';
import { AppState } from '@state/app.state';
import { setUnsavedBathroomsFiltersAction } from '@state/filters/filters.actions';
import { selectFiltersCurrent } from '@state/filters/filters.selectors';

@UntilDestroy()
@Component({
  selector: 'app-filter-v2-baths',
  templateUrl: './filter-v2-baths.component.html',
  styleUrls: [
    './filter-v2-baths.component.scss',
    '../filters-v2.component.scss',
  ],
})
export class FilterV2BathsComponent implements OnInit {
  public minValue = 0;
  public maxValue = 0;

  constructor(private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loadInitialValue();

    // for clearing the filters
    this.store
      .select(selectFiltersCurrent)
      .pipe(untilDestroyed(this))
      .subscribe((filters) => {
        if (
          !filters?.bathrooms ||
          (!filters.bathrooms.greaterThanOrEqual &&
            !filters.bathrooms.lessThanOrEqual)
        ) {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }

  handleChange() {
    if (this.minValue > this.maxValue && this.maxValue > 0) {
      this.maxValue = this.minValue;
    }

    let bathroomsQuery: IFilterNumber = {};
    if (this.minValue > 0) {
      bathroomsQuery.greaterThanOrEqual = this.minValue;
    }
    if (this.maxValue > 0) {
      bathroomsQuery.lessThanOrEqual = this.maxValue;
    }

    this.store.dispatch(setUnsavedBathroomsFiltersAction(bathroomsQuery));
  }

  loadInitialValue() {
    this.store
      .select(selectFiltersCurrent)
      .pipe(take(1))
      .subscribe((filters) => {
        if (filters?.bathrooms) {
          if (filters.bathrooms.greaterThanOrEqual) {
            this.minValue = filters.bathrooms.greaterThanOrEqual;
          } else {
            this.minValue = 0;
          }
          if (filters.bathrooms.lessThanOrEqual) {
            this.maxValue = filters.bathrooms.lessThanOrEqual;
          } else {
            this.maxValue = 0;
          }
        } else {
          this.minValue = 0;
          this.maxValue = 0;
        }
      });
  }
}
